import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const PROCESS_TASK_CUSTOMER_LOADED = NS + 'PROCESS_TASK_CUSTOMER_LOADED'

export const CUSTOMER_LOADED = NS + 'CUSTOMER_LOADED'

export const FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST =
    NS + 'FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST'
export const FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS =
    NS + 'FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS'
export const FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR =
    NS + 'FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR'

export const CHANGE_TREATMENT_QUOTATION = NS + 'CHANGE_TREATMENT_QUOTATION'
export const CHANGE_TREATMENT_PACKAGE_PRICE =
    NS + 'CHANGE_TREATMENT_PACKAGE_PRICE'

export const SAVE_TREATMENT_QUOTATION_REQUEST =
    NS + 'SAVE_TREATMENT_QUOTATION_REQUEST'
export const SAVE_TREATMENT_QUOTATION_SUCCESS =
    NS + 'SAVE_TREATMENT_QUOTATION_SUCCESS'
export const SAVE_TREATMENT_QUOTATION_ERROR =
    NS + 'SAVE_TREATMENT_QUOTATION_ERROR'

export const OPEN_PREVIEW_MODAL = NS + 'OPEN_PREVIEW_MODAL'
export const CLOSE_PREVIEW_MODAL = NS + 'CLOSE_PREVIEW_MODAL'

export const UPLOAD_SCAN_VIDEO_REQUEST = NS + 'UPLOAD_SCAN_VIDEO_REQUEST'
export const UPLOAD_SCAN_VIDEO_SUCCESS = NS + 'UPLOAD_SCAN_VIDEO_SUCCESS'
export const UPLOAD_SCAN_VIDEO_ERROR = NS + 'UPLOAD_SCAN_VIDEO_ERROR'

export const SET_EDITABLE_FOR_USER = NS + 'SET_EDITABLE_FOR_USER'



// WEBPACK FOOTER //
// ./src/modules/treatment/state/quotation/type.js